// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1Rwza","vLegacy":"SelectSecondary_vLegacy__JR5Nt","error":"SelectSecondary_error__quXQO","disabled":"SelectSecondary_disabled__3HCmu"};